<template>
    <div style="border-bottom: 1px solid transparent" v-if="cvDetail.basic_info.lang === 'cn' && !cvDetail.basic_info.mentor_id " id="1" data-growing-container>
      <div v-if="flag" class="jobscan-card" @click="toDetail">
        <div class='title' v-html="matchText.title"></div>
        <div class="content">
          <div class="img">
            <div class="echart-box">
              <div class="point FF5C5C"><div></div></div>
              <div class="point AC5DD9"><div></div></div>
              <div class="point FDAC42"><div></div></div>
              <div class="point a5B8DEF"><div></div></div>
              <div class="point a39D98A"><div></div></div>
              <div id="main">
              </div>
            </div>
            <div class="total-box">{{report.total_score}}分</div>
            <div class="create-time">生成于：{{report.created_at}}</div>
          </div>
          <div class="list">
            <div class="list-item">
              <div class="dot"></div>
              <div>简历亮点 {{report.scores.overall}}分</div>
            </div>
            <div class="list-item">
              <div class="dot green"></div>
              <div>教育背景 {{report.scores.education}}分</div>
            </div>
            <div class="list-item">
              <div class="dot blue"></div>
              <div>工作背景 {{report.scores.work}}分</div>
            </div>
            <div class="list-item">
              <div class="dot"></div>
              <div>技能分析 {{report.scores.skills}}分</div>
            </div>
            <div class="mask">
            </div>
            <a class="btn">查看完整报告</a>
          </div>
        </div>
      </div>
      <div v-show="false" @click="toTestPage" class="not-report">
        <div class="not-header">
          <p class="title">你的简历在 HR 眼里怎么样？</p>
          <p class="subtitle">智能分析你的简历竞争力，让求职更有把握</p>
          <img src="https://files.wondercv.com/pc/jobscan/new.gif" width="40" height="17"/>
        </div>
        <div class="content">
          <div class="img">
            <div class="echart-box">
              <div class="point FF5C5C"><div></div></div>
              <div class="point AC5DD9"><div></div></div>
              <div class="point FDAC42"><div></div></div>
              <div class="point a5B8DEF"><div></div></div>
              <div class="point a39D98A"><div></div></div>
              <div id="main1">
              </div>
            </div>
            <div class="total-box">?分</div>
            <div class="create-time">17255 人已经生成报告</div>
          </div>
          <div class="list">
            <div class="list-item">
              <div class="dot"></div>
              <div>简历亮点 25分</div>
            </div>
            <div class="list-item">
              <div class="dot green"></div>
              <div>教育背景 25分</div>
            </div>
            <div class="list-item">
              <div class="dot blue"></div>
              <div>工作背景 16分</div>
            </div>
            <div class="list-item">
              <div class="dot"></div>
              <div>技能分析 25分</div>
            </div>
            <div class="mask">
            </div>
            <div class="btn" @click.stop="toTestPage">立即测一测</div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import {mapMutations, mapState} from "vuex";
    import api from "../../../../../api";
    var echarts = require('echarts');

    export default {
      name: 'Jobscan',
      computed:{
        ...mapState('editor', [ 'score',"cvDetail", 'isShowJobscanGuide' ]),
        matchText(){
          let total = this.report.total_score
          let post_name = this.report.target_job_name
          let matchTitle = {
            title:"",
            subtitle:""
          }
          if(total >= 0 && total < 30){
            matchTitle.title = `当前简历与<span>${post_name}</span>的匹配度较低`
            matchTitle.subtitle = '建议根据目标岗位的任职要求修改简历哦'
          }else if( total >= 30 && total < 60 ){
            matchTitle.title = `当前简历与<span>${post_name}</span>的匹配度一般`
            matchTitle.subtitle = '建议根据目标岗位的任职要求修改简历哦'
          }else if( total >= 60 && total < 80 ){
            matchTitle.title = `当前简历与<span>${post_name}</span>较为匹配`
            matchTitle.subtitle = '现在投递简历，通过率可达 80% 哦'
          }else if( total >= 80 && total < 100 ){
            matchTitle.title = `你就是<span>${post_name}</span>岗的天选之子`
            matchTitle.subtitle = '立刻投递简历，通过率高达 95% 哦'
          }

          return  matchTitle
        }
      },
      mounted(){
        this.getReport()
      },
      data(){
        return{
          flag: false,//是否有报告
          report: {}
        }
      },
      methods:{
        ...mapMutations('editor', ['setIsShowJobscanGuide', 'setHasJobscanRepor' ]),
        async getReport(){
          try {
            let res = await api.jobs.getBriefReport({cv_token:this.$route.params.token})
            if(res.code === 1000){
              this.flag = true
              this.setIsShowJobscanGuide(false)
              this.setHasJobscanRepor(true)
              this.report = res.data
              setTimeout(()=>{
                this.eChartInit(document.querySelector("#main"))
              },500)
            }else{
              this.flag = false
              this.setHasJobscanRepor(false)
              setTimeout(()=>{
                this.eChartInit(document.querySelector("#main1"))
              },500)
            }
          }catch (e) {
            console.error("获取简易报告异常",e)
          }
        },
        eChartInit(dom){
          // 基于准备好的dom，初始化echarts实例
          let myChart = echarts.init(dom);
          // 绘制图表
          let option = {
            grid:{
              top:0,
              left:0,
              bottom:10,
              right:0,
            },
            radar: {
              indicator: [
                {text: '', max: 15,color:"#FF5C5C"},
                {text: '', max: 5,color:"#AC5DD9"},
                {text: '', max: 15,color:"#FDAC42"},
                {text: '', max: 35,color:"#5B8DEF"},
                {text: '', max: 30,color:"#39D98A"}
              ],
              radius: ["0%", "100%"],
              splitNumber: 4,
              axisLine:{
                show: true,
                // symbol: 'circle',
                lineStyle:{
                  color: "#ececec",
                  width: 0.5
                }
              },
              splitLine: {
                lineStyle: {
                  width: 0.5
                }
              },
              textStyle:{
                rich:{

                }
              },
              splitArea:{
                show: false
              }
            },
            series: [
              {
                type: 'radar',
                symbol: "none",
                itemStyle:{
                  color:'rgba(128, 128, 128, 0)',
                  opacity: 0
                },
                areaStyle:{
                  color:"rgba(255,102,68, 0.4)"
                },
                data: [{value: !this.flag ? [13, 4, 10, 28, 20] : [this.report.scores.overall, this.report.scores.abilities, this.report.scores.skills, this.report.scores.work, this.report.scores.education]}]
              }
            ]
          }
          myChart.setOption(option);
        },
        toTestPage(){

          if(this.score < 60){
            this.$message.error("当前简历内容较少，请完善到 60 分以上再进行分析哦~")
            return
          }
          this.setIsShowJobscanGuide(false)
          window.open(`/jobscan/index/?token=${this.$route.params.token}&name=${this.cvDetail.basic_info.cv_name}`)
        },
        toDetail(){
          window.open(`/jobscan/results/${this.report.token}.html?form=editor`,'_blank')
        }
      }
    }
        
    
  
</script>
<style lang="scss" scoped>
    .jobscan-card{
      cursor: pointer;
        margin-top: 16px;
        background: #fff;
        padding: 15px 24px 30px 24px;
        box-sizing: border-box;
        border-radius: 4px;
        margin-bottom: 64px;
        .title{
          font-size: 16px;
          color: #404040;
          font-weight: 600;
          line-height: 22px;
          margin-bottom: 21px;
          /deep/span{
            color: #ff6644;
          }
        }
        .content{
          display: flex;
          justify-content: space-between;
          .img{
            flex:1;
            position: relative;
          }
          .create-time{
            font-size: 12px;
            color: #BCBCBC;
          }
          #main{
            width: 100px;
            height: 100px;
          }
          .list{
            flex: 1;
            position: relative;
            .dot{
              width: 12px;
              height: 6px;
              background: #FF5C5C;
              border-radius: 3px;
              opacity: 0.78;
              margin-right: 12px;
            }
            .list-item{
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #404040;
              margin-bottom: 12px;
            }
            .mask{
              width: 100%;
              height: 64px;
              position: absolute;
              bottom: 0;
              left: 0;
              background: linear-gradient(180deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.68) 30%, #FFFFFF 63%, #FFFFFF 100%);
            }
            .btn{
              width: 120px;
              height: 32px;
              background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
              border-radius: 16px;
              position: absolute;
              left: 0;
              bottom: -10px;
              text-align: center;
              line-height: 32px;
              font-weight: 400;
              color: #FFFFFF;
              cursor: pointer;
              display: block;
              &:hover{
                opacity: 0.8;
              }
            }
            .dot.green{
              background:#39D98A;
            }
            .dot.blue{
              background:#5B8DEF;
            }
          }
        }
        
    }
    .not-report{
      cursor: pointer;
      margin-top: 16px;
      width: 100%;
      background-color: #fff;
      margin-bottom: 64px;
      border-radius: 4px;
      .not-header{
        height: 60px;
        background: #FF6F4E;
        border-radius: 4px 4px 0px 0px;
        box-sizing: border-box;
        padding: 10px 24px;
        color: #fff;
        position: relative;
        .title{
          font-size: 16px;
          line-height: 20px;
          /deep/span{
            color: #ff6644;
          }
        }
        .subtitle{
          font-size: 12px;
          line-height: 20px;
        }
        img{
          position: absolute;
          right:17px;
          top:13px
        }
      }
      .content{
        display: flex;
        justify-content: space-between;
        padding: 20px 42px 32px 22px;
        .img{
          flex:1;
          position: relative;
        }
        .create-time{
          font-size: 12px;
          font-weight: 400;
          color: #FF6644;
          line-height: 12px;
        }
        #main1{
          width: 100px;
          height: 100px;
        }
        .list{
          flex: 1;
          position: relative;
          .dot{
            width: 12px;
            height: 6px;
            background: #FF5C5C;
            border-radius: 3px;
            opacity: 0.78;
            margin-right: 12px;
          }
          .list-item{
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #404040;
            margin-bottom: 12px;
          }
          .mask{
            width: 100%;
            height: 64px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.68) 30%, #FFFFFF 63%, #FFFFFF 100%);
          }
          .btn{
            width: 120px;
            height: 32px;
            background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
            border-radius: 16px;
            position: absolute;
            left: 0;
            bottom: -10px;
            text-align: center;
            line-height: 32px;
            font-weight: 400;
            color: #FFFFFF;
            cursor: pointer;
            display: block;
            &:hover{
              opacity: 0.8;
            }
          }
          .dot.green{
            background:#39D98A;
          }
          .dot.blue{
            background:#5B8DEF;
          }
        }
      }

    }
    .echart-box{
      width: 100%;
      height: 100%;
      position: relative;
    }
    .total-box{
      position: absolute;
      top:40px;
      font-size: 18px;
      font-weight: 600;
      color: #f64;
      z-index: 3;
      left: 33px;
      /*background-color: rgba(255,255,255,.4);*/
    }
    .point{
      position: absolute;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: red;
      z-index: 3;
      &>div{
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background-color: #fff;
        margin: 1px;
      }
      &.FF5C5C{
        background-color: #FF5C5C;
        top: -2px;
        left: 48px;
      }
      &.AC5DD9{
        background-color: #AC5DD9;
        top: 33px;
        left: 0px;
      }
      &.FDAC42{
        background-color: #FDAC42;
        top: 89px;
        left: 18px;
      }
      &.a5B8DEF{
        background-color: #5B8DEF;
        top: 89px;
        left: 78px;
      }
      &.a39D98A{
        background-color: #39D98A;
        top: 33px;
        left: 96px;
      }

    }
    .active{
      position: relative;
      z-index: 10;
    }
</style>